import { jsxs as N, jsx as a } from "react/jsx-runtime";
import * as c from "react";
import { c as H, a as I, b as M } from "../index-Dn5fq5RO.js";
import { u as j } from "../index-BwdHfdWj.js";
import { u as B } from "../index-BZPx6jYI.js";
import { u as q } from "../index-BuFJZcOe.js";
import { P as C } from "../index-Bo0P2KXg.js";
var S = "Switch", [z, Y] = H(S), [A, O] = z(S), P = c.forwardRef(
  (e, o) => {
    const {
      __scopeSwitch: t,
      name: s,
      checked: r,
      defaultChecked: h,
      required: i,
      disabled: n,
      value: u = "on",
      onCheckedChange: f,
      form: b,
      ...p
    } = e, [d, T] = c.useState(null), x = j(o, (m) => T(m)), w = c.useRef(!1), k = d ? b || !!d.closest("form") : !0, [l = !1, g] = I({
      prop: r,
      defaultProp: h,
      onChange: f
    });
    return /* @__PURE__ */ N(A, { scope: t, checked: l, disabled: n, children: [
      /* @__PURE__ */ a(
        C.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": l,
          "aria-required": i,
          "data-state": _(l),
          "data-disabled": n ? "" : void 0,
          disabled: n,
          value: u,
          ...p,
          ref: x,
          onClick: M(e.onClick, (m) => {
            g((E) => !E), k && (w.current = m.isPropagationStopped(), w.current || m.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ a(
        D,
        {
          control: d,
          bubbles: !w.current,
          name: s,
          value: u,
          checked: l,
          required: i,
          disabled: n,
          form: b,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
P.displayName = S;
var R = "SwitchThumb", y = c.forwardRef(
  (e, o) => {
    const { __scopeSwitch: t, ...s } = e, r = O(R, t);
    return /* @__PURE__ */ a(
      C.span,
      {
        "data-state": _(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...s,
        ref: o
      }
    );
  }
);
y.displayName = R;
var D = (e) => {
  const { control: o, checked: t, bubbles: s = !0, ...r } = e, h = c.useRef(null), i = B(t), n = q(o);
  return c.useEffect(() => {
    const u = h.current, f = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (i !== t && p) {
      const d = new Event("click", { bubbles: s });
      p.call(u, t), u.dispatchEvent(d);
    }
  }, [i, t, s]), /* @__PURE__ */ a(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: t,
      ...r,
      tabIndex: -1,
      ref: h,
      style: {
        ...e.style,
        ...n,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function _(e) {
  return e ? "checked" : "unchecked";
}
var F = P, L = y;
const U = "_switchRoot_btcui_1", W = "_switchThumb_btcui_55", v = {
  switchRoot: U,
  switchThumb: W
}, X = c.forwardRef((e, o) => /* @__PURE__ */ a(F, { ref: o, className: v.switchRoot, ...e, children: /* @__PURE__ */ a(L, { className: v.switchThumb }) }));
X.displayName = "Switch";
export {
  X as Switch
};
